import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

class SplideCustomizations {
	constructor() {
		this.initialized = false;
	}

	init() {
		if (this.initialized || !this.isFrontend()) {
			return;
		}

		this.overrideMount();

		this.initialized = true;
	}

	overrideMount() {
		const autoscrollCssClass = 'tht-slider-autoscroll';
		const originalMount = window.Splide?.prototype?.mount;
		const prefersReducedMotion = window.matchMedia(
			'(prefers-reduced-motion: reduce)'
		).matches;

		if (!originalMount || originalMount.thtAutoScrollPatched) {
			return;
		}

		function mount(extensions, transition) {
			if (
				this.root?.matches(`.${autoscrollCssClass}`) &&
				!prefersReducedMotion
			) {
				extensions = {
					...(extensions || {}),
					AutoScroll,
				};
			}

			return originalMount.call(this, extensions, transition);
		}

		mount.thtAutoScrollPatched = true;
		window.Splide.prototype.mount = mount;
	}

	isFrontend() {
		return document.body.classList.contains('bricks-is-frontend');
	}
}

export const splideCustomizations = new SplideCustomizations();
